import React from 'react';
import { X, RefreshCw } from 'lucide-react';

interface RefreshPromptModalProps {
  isOpen: boolean;
  onClose: () => void; // Called when "Continue Loading" or X is clicked
  onRefresh: () => void; // Called when "Refresh Now" is clicked
}

const RefreshPromptModal: React.FC<RefreshPromptModalProps> = ({ isOpen, onClose, onRefresh }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-gray-800">Page Load Optimization</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
            aria-label="Close modal"
          >
            <X size={24} />
          </button>
        </div>
        <p className="text-gray-600 mb-6">
          For the best experience after switching tabs, we recommend refreshing this page to ensure all data is up to date.
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
          >
            Continue Loading
          </button>
          <button
            onClick={onRefresh}
            className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark flex items-center"
          >
            <RefreshCw size={16} className="mr-2" />
            Refresh Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefreshPromptModal;
